import {
  TextMatchTransformer,
  TRANSFORMERS as DEFAULT_TRANSFORMERS,
} from '@lexical/markdown';
import {
  $isAttachmentNode,
  AttachmentNode,
  $createAttachmentNode,
} from './customNodes';
import { $isTextNode, TextNode } from 'lexical';
import { TABLE } from './transformers/tableTransformers';
import { DIFF_HUNK } from './transformers/diffHunkTransformer';
import { LONG_DIFF_HUNK } from './transformers/longDiffHunkTransformer';
import { HORIZONTAL_RULE } from '../../../../../MarkdownEditor/Lexical/transformers/horizontalRule';

export const FOOTNOTE_REGEX = /\[\^([A-Za-z0-9_]+)\](?!:)/;
export const FOOTNOTE_REFERENCE_REGEX = /\[\^([A-Za-z0-9_]+)\]:/;
export const ATTACHMENT_REGEX = /\[footnote_ref:(\d+):([^\]]*)\]/;
export const INS_REGEX = /<ins>(.*?)<\/ins>/;

export const ATTACHMENT: TextMatchTransformer = {
  dependencies: [AttachmentNode],

  regExp: ATTACHMENT_REGEX,
  importRegExp: ATTACHMENT_REGEX,

  replace: (textNode, match) => {
    const [, id, reference] = match;
    const attachmentNode = $createAttachmentNode(id, reference);
    textNode.replace(attachmentNode);
  },

  export: node => {
    if (!$isAttachmentNode(node)) {
      return null;
    }
    return `[footnote_ref:${node.__id}:${node.__reference}]`;
  },

  type: 'text-match',
};

const FOOTNOTE: TextMatchTransformer = {
  dependencies: [AttachmentNode],

  regExp: FOOTNOTE_REGEX,
  importRegExp: FOOTNOTE_REGEX,

  replace: (textNode, match) => {
    const [, reference] = match;
    const attachmentNode = $createAttachmentNode('0', reference);
    textNode.replace(attachmentNode);
  },

  export: node => {
    if (!$isAttachmentNode(node)) {
      return null;
    }
    return `[footnote_ref:${node.__id}:${node.__reference}]`;
  },

  type: 'text-match',
};

const FOOTNOTE_REFERENCE: TextMatchTransformer = {
  dependencies: [AttachmentNode],

  regExp: FOOTNOTE_REFERENCE_REGEX,
  importRegExp: FOOTNOTE_REFERENCE_REGEX,

  replace: textNode => {
    textNode.remove();
  },

  type: 'text-match',
};

// This transformer handles <ins> tags for underline formatting
export const INS: TextMatchTransformer = {
  dependencies: [TextNode],

  regExp: INS_REGEX,
  importRegExp: INS_REGEX,

  replace: (textNode, match) => {
    const [, content] = match;
    if (content) {
      textNode.setTextContent(content);
      textNode.toggleFormat('underline');
    }
  },

  export: node => {
    if (!$isTextNode(node) || !node.hasFormat('underline')) {
      return null;
    }
    return `<ins>${node.getTextContent()}</ins>`;
  },
  type: 'text-match',
};

// Transformers for import (loading markdown) - excludes TABLE and DIFF_HUNK to avoid interference
// (both are handled by post-processing plugins instead).
// LONG_DIFF_HUNK must come before DEFAULT_TRANSFORMERS so it intercepts
// 4+-backtick diff fences before Lexical's CODE transformer sees them.
export const LOAD_TRANSFORMERS = [
  HORIZONTAL_RULE,
  LONG_DIFF_HUNK,
  ATTACHMENT,
  FOOTNOTE,
  FOOTNOTE_REFERENCE,
  INS,
  ...DEFAULT_TRANSFORMERS,
];

// Transformers for export (saving to markdown) - includes TABLE for conversion
export const SAVE_TRANSFORMERS = [
  DIFF_HUNK,
  TABLE,
  HORIZONTAL_RULE,
  ATTACHMENT,
  FOOTNOTE,
  FOOTNOTE_REFERENCE,
  INS,
  ...DEFAULT_TRANSFORMERS,
];
